const MERGED_SOURCE = 'merge';

export const isMergedSource = (source: any): boolean =>
  typeof source === 'string' && source.toLowerCase() === MERGED_SOURCE;

export const areAllDocumentsMerged = (documents: any[] = []): boolean =>
  documents.length > 0 && documents.every((document) => isMergedSource(document?.source));

export const getMergedSelectedFileNames = (selectedRows: any[] = []): string[] =>
  selectedRows
    .filter((row) => isMergedSource(row?.source))
    .map((row) => row?.name || row?.originalName || row?.id || '')
    .filter(Boolean);

export const getMergedFilesTooltip = (fileNames: string[] = []): string => {
  if (fileNames.length === 0) {
    return '';
  }

  if (fileNames.length === 1) {
    return `This option can't be used for the merged file ${fileNames[0]}`;
  }

  return `This option can't be used for the merged files ${fileNames.join(' , ')}`;
};
